//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFSelectField from '../ReduxFormComps/RFSelectField'
import type { SingleSelectAnswerQuestion$Type } from './flowTypes'

const styles = {
    selectFieldStyle: {
        width: '270px',
        paddingBottom: '10px'
    },
}

const SingleSelectAnswerQuestion=(props: SingleSelectAnswerQuestion$Type)=>{
    return (
        <div className='row'>
            <div className='col-sm'>
                <Field
                        label={props.questionText}
                        name={props.elementId}
                        datas={props.answers}
                        component={RFSelectField}
                        codeField={'field'}
                        descField={'label'}
                        customStyle={styles.selectFieldStyle}
                /> 
            </div>
        </div>
    )
}

export default SingleSelectAnswerQuestion


// WEBPACK FOOTER //
// ./src/components/QualityReview/SingleSelectAnswerQuestion.js